import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ModalImage from "react-modal-image";
import { Link } from "react-router-dom";

import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import Footer from "../../components/Footer";
import { Styles } from "./styles/gallery.js";

import axios from "axios";
import { Constant, imageDomain } from "../../helper/Constants.js";

class Gallery extends Component {
  state = {
    items: [],
    loading: true,
    error: null,
    page: 1,
    limit: 9, // 9 items per page (3 x 3 grid)
    totalPages: 1,
    totalDocs: 0,
  };

  componentDidMount() {
    const { page, limit } = this.state;
    this.fetchGallery(page, limit);
  }

  // Build full media URL
  getMediaUrl = (mediaPath) => {
    if (!mediaPath) return process.env.PUBLIC_URL + "/assets/images/default-gallery.jpg";
    if (/^https?:\/\//i.test(mediaPath)) return mediaPath;
    return imageDomain.replace(/\/+$/, "") + "/" + mediaPath.replace(/^\/+/, "");
  };

  fetchGallery = async (page = 1, limit = this.state.limit) => {
    this.setState({ loading: true, error: null });

    try {
      const baseUrl =
        (Constant && Constant.getUrls && Constant.getUrls.getAllGalleryImages) ||
        "/gallery";

      const resp = await axios.get(`${baseUrl}?page=${page}&limit=${limit}`);
      const payload = resp?.data || {};

      // Try to read items array in a flexible way
      const items =
        Array.isArray(payload.data) ? payload.data :
        Array.isArray(payload.data?.docs) ? payload.data.docs :
        Array.isArray(payload.docs) ? payload.docs :
        [];

      const pagination = payload.pagination || payload.data?.pagination || {};

      const totalDocs = pagination.total || items.length || 0;
      const totalPages =
        pagination.totalpage ||
        (limit ? Math.ceil(totalDocs / limit) : 1);

      this.setState({
        items,
        loading: false,
        page: pagination.page || page,
        totalPages,
        totalDocs,
      });
    } catch (err) {
      console.error("Failed to fetch gallery:", err);
      this.setState({
        loading: false,
        error: "Failed to fetch gallery",
        items: [],
      });
    }
  };

  handlePageChange = (newPage) => {
    const { totalPages, limit } = this.state;
    if (newPage < 1 || newPage > totalPages) return;
    this.fetchGallery(newPage, limit);
  };

  render() {
    const { items, loading, error, page, totalPages } = this.state;

    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper gallery-page">
          {/* Header */}
          <Header />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Gallery" />

          {/* Gallery Area */}
          <section className="gallery-page-area">
            <Container>
              <Row>
                {loading ? (
                  <Col md="12" className="text-center">
                    <p>Loading...</p>
                  </Col>
                ) : error ? (
                  <Col md="12" className="text-center">
                    <p style={{ color: "red" }}>{error}</p>
                  </Col>
                ) : items.length === 0 ? (
                  <Col md="12" className="text-center">
                    <p>No gallery items found.</p>
                  </Col>
                ) : (
                  items.map((item, i) => {
                    const url = this.getMediaUrl(item.image || item.media || "");
                    const type = item.form_type || item.media_type || "image"; // default image

                    return (
                      <Col lg="4" sm="6" key={item._id || i}>
                        <div className="gallery-box">
                          {type === "video" ||
                          /\.(mp4|webm|ogg)$/i.test(url) ? (
                            <video
                              src={url}
                              controls
                              style={{
                                width: "100%",
                                height: "250px",
                                objectFit: "cover",
                                borderRadius: "5px",
                              }}
                            >
                              Your browser does not support the video tag.
                            </video>
                          ) : (
                            <ModalImage
                              small={url}
                              large={url}
                              alt="Gallery item"
                            />
                          )}
                        </div>
                      </Col>
                    );
                  })
                )}

                {/* Pagination */}
                {!loading && totalPages > 1 && (
                  <Col md="12" className="text-center">
                    <ul className="pagination-box list-unstyled list-inline">
                      {/* First page */}
                      <li className="list-inline-item">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a onClick={() => this.handlePageChange(1)}>
                          <i className="las la-angle-double-left"></i>
                        </a>
                      </li>

                      {/* Page numbers with ellipsis like blogs/events */}
                      {Array.from({ length: totalPages }, (_, idx) => idx + 1)
                        .filter((p) => {
                          if (p === 1 || p === totalPages) return true;
                          if (Math.abs(p - page) <= 2) return true;
                          return false;
                        })
                        .map((p, index, arr) => {
                          const prev = arr[index - 1];
                          const gap = prev && p - prev > 1;
                          return (
                            <React.Fragment key={p}>
                              {gap && (
                                <li className="list-inline-item">
                                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                  <a
                                    style={{
                                      border: "none",
                                      background: "transparent",
                                      cursor: "default",
                                    }}
                                  >
                                    …
                                  </a>
                                </li>
                              )}
                              <li
                                className={`list-inline-item ${
                                  p === page ? "active" : ""
                                }`}
                              >
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <a onClick={() => this.handlePageChange(p)}>
                                  {p}
                                </a>
                              </li>
                            </React.Fragment>
                          );
                        })}

                      {/* Last page */}
                      <li className="list-inline-item">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a onClick={() => this.handlePageChange(totalPages)}>
                          <i className="las la-angle-double-right"></i>
                        </a>
                      </li>
                    </ul>
                  </Col>
                )}
              </Row>
            </Container>
          </section>

          {/* Footer */}
          <Footer />
        </div>
      </Styles>
    );
  }
}

export default Gallery;
